import { render, staticRenderFns } from "./FavoriteDetail.vue?vue&type=template&id=2890a56c&scoped=true"
import script from "./FavoriteDetail.vue?vue&type=script&lang=js"
export * from "./FavoriteDetail.vue?vue&type=script&lang=js"
import style0 from "./FavoriteDetail.vue?vue&type=style&index=0&id=2890a56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890a56c",
  null
  
)

export default component.exports